export enum STATUS_TYPES {
  NOT_HANDLED_YET = 1,
  NO_ANSWER = 2,
  CALL_LATER = 3,
  ANSWERED = 4,
  WRONG_PHONE = 5,
}

export enum TREATING_FACTOR {
  CLINIC = 143,
  WELFARE = 144,
  SOCIAL = 145,
}
